<template>
	<div style="overflow: hidden;">

		<div>
			TUpload{{speedUnits}}
			<el-button size="mini" type="primary" @click="customButtonClick">上传<i
					class="el-icon-upload el-icon--right"></i></el-button>

			<input :ref="randomId" type="file" class="custom-input" @change='upload($event,0)'
				style='display: none !important;'>
			<span style="float: right;width: 260px;margin-left: 30px;font-size: 12px;">
				<el-progress :percentage="progress" :color="colors" :width="80"></el-progress>
				剩余时间：{{progress==100?0:resttime}}&nbsp;&nbsp;&nbsp;
				速度：{{progress==100?0:speedUnits}}
			</span>

		</div>
		<div style="margin-top: 10px;">

			<el-input size="mini" placeholder="请输入url" v-model="insertUrl" class="input-with-select">
				<el-button slot="append" size="mini" type="primary" @click="insert">插入</el-button>
			</el-input>

		</div>
		<div style="width:100%;height:30px;"></div>
		<div style="width:100%;">
			<template v-for="(item, index) in uploadImg">
				<div :key="index" v-if="item.type=='image'"
					style="margin-bottom:10px;width:150px;height:110px;word-wrap: break-word;word-break: normal;float:left;border-bottom:1px solid gray;position:relative;margin-right:10px;">

					<div style="width:150px;height:80px;object-fit: contain;">
						<img style="object-fit: contain;width: 100%;height: 100%;" :src="item.url"></img>
					</div>
					<div style="width:150px;height:20px;padding-top: 5px;padding-left: 3px;">
						<i class="el-icon-delete" :data-index="index" @click="removeImg"></i>
						<a style="font-size: 12px;color:el-icon-document-copy" @click="copyLink(item.url,item.id)"
							:class="item.id + 'tag'">复制链接</a>
					</div>

				</div>
				<div :key="index" v-if="item.type=='vedio'"
					style="margin-bottom:10px;width:150px;height:110px;word-wrap: break-word;word-break: normal;float:left;border-bottom:1px solid gray;position:relative;margin-right:10px;">
					<div style="width:150px;height:80px;">
						<video style="object-fit: contain;width: 100%;height: 100%;" :src="item.url"
							controls="controls">
							您的浏览器不支持 video 标签。
						</video>
					</div>
					<div style="width:150px;height:20px;padding-top: 5px;padding-left: 3px;">
						<i class="el-icon-delete" :data-index="index" @click="removeImg"></i>
						<a style="font-size: 12px;color:el-icon-document-copy" @click="copyLink(item.url,item.id)"
							:class="item.id + 'tag'">复制链接</a>
					</div>
				</div>
				<div :key="index" v-if="item.type=='doc'"
					style="margin-bottom:10px;width:150px;height:110px;word-wrap: break-word;word-break: normal;float:left;border-bottom:1px solid gray;position:relative;margin-right:10px;">
					<div style="width:150px;height:80px;">
						<span>{{item.title}}</span>
					</div>
					<div style="width:150px;height:20px;padding-top: 5px;padding-left: 3px;">
						<i class="el-icon-delete" :data-index="index" @click="removeImg"></i>
						<a style="font-size: 12px;color:el-icon-document-copy" @click="copyLink(item.url,item.id)"
							:class="item.id + 'tag'">复制链接</a>
					</div>
				</div>
				<div :key="index" v-if="!item.type"
					style="margin-bottom:10px;width:150px;height:110px;word-wrap: break-word;word-break: normal;float:left;border-bottom:1px solid gray;position:relative;margin-right:10px;">
					<div style="width:150px;height:80px;">
						<span>{{item.title}}</span>
					</div>
					<div style="width:150px;height:20px;padding-top: 5px;padding-left: 3px;">
						<i class="el-icon-delete" :data-index="index" @click="removeImg"></i>
						<a style="font-size: 12px;color:el-icon-document-copy" @click="copyLink(item.url,item.id)"
							:class="item.id + 'tag'">复制链接</a>
					</div>
				</div>
			</template>
		</div>

	</div>
</template>
<script>
	import Common from './js/Common'
	import plugins from '../../register/plugin.js'
	import store from 'store/'
	import spark from '../../utils/sparkmd5.js'
	import func from '../../utils/func/func.js'
	import Clipboard from 'clipboard'

	var COS = require('cos-js-sdk-v5'); /* 安装命令 npm i cos-js-sdk-v5 --save */
	var Js = Common('upload')
	Js.mixins = [{
		data() {
			return {
				defaultProps: {
					children: 'child',
					label: 'title',
					value: 'id',
				},
				uploadImg: [],
				insertUrl: '',
				speedUnits: '0 b/s',
				progress: 0,
				resttime: 0,
				finishCount: 0,
				colors: [{
						color: '#f56c6c',
						percentage: 20
					},
					{
						color: '#e6a23c',
						percentage: 40
					},
					{
						color: '#5cb87a',
						percentage: 60
					},
					{
						color: '#1989fa',
						percentage: 80
					},
					{
						color: '#6f7ad3',
						percentage: 100
					}
				],
				randomId: Math.ceil(Math.random() * 10000) + 'file',
				insertUrl: ''


			}
		},
		created() {
			if (!this.defaultValue || !Array.isArray(this.defaultValue)) {
				this.uploadImg = []
			} else {
				this.uploadImg = this.defaultValue;
			}
		},
		mounted() {

		},
		computed: {},
		methods: {


			copyLink(url, id) {
				const self = this;
				let clipboard = new Clipboard('.' + id + 'tag', {
					text: function() {
						return url
					}
				})
				clipboard.on('success', e => {
					func.notify('复制成功', 'success');
					clipboard.destroy()
				})
				clipboard.on('error', e => {
					func.notify('复制失败', 'warning');
					clipboard.destroy()
				})
			},

			copyUrl(index) {
				console.log(index);
				const self = this;
				self.uploadImg[index]['showUrl'] = true;
				self.$set(self.uploadImg, index, self.uploadImg[index]);

			},

			insert() {
				const self = this;
				var url = self.insertUrl; //获取到了图片的URL


				var lastArray = self.insertUrl.split("/");
				self.orginName = lastArray[lastArray.length - 1];
				var obj = self.orginName.lastIndexOf(".");
				self.ext = self.orginName.substr(obj + 1);

				//判断文件类型渲染(H5 video标签只支持H264编码的MP4)
				var videoArray = ['mp4'];
				var imageArray = ['image', 'jpeg', 'png', 'PNG', 'JPEG', 'jpg', 'JPG'];
				var docArray = ['doc', 'xlsx', 'xls', 'csv', 'pdf', 'txt', 'ppt'];

				if (videoArray.indexOf(self.ext) != -1) {
					self.uploadImg.push({
						url: url,
						type: 'vedio',
					});
				} else if (imageArray.indexOf(self.ext) != -1) {
					self.uploadImg.push({
						url: url,
						type: 'image'
					});
				} else if (docArray.indexOf(self.ext) != -1) {
					self.uploadImg.push({
						url: url,
						title: self.orginName,
						type: 'doc'
					});
				} else {
					self.uploadImg.push({
						url: url,
						title: self.orginName,
					});
				};

				self.$emit('onChange', {
					field: self.field,
					value: self.uploadImg
				});
				self.insertUrl = "";

			},


			customButtonClick() {
				const self = this;
				self.$refs[self.randomId].click(); //打开file 选择图片
			},


			async upload(e, start) {

				const self = this;

				var cos = new COS({
					SecretId: 'AKIDxjFUTBdoW2KNAi15tSmrgGZdQ3RaS3OT',
					SecretKey: 'rSpysXx72h6GBqGRM2SfdMq55sPghSyE',
				});
			
				let fileObj = e.target.files[0];
				self.size = fileObj.size;
				var key = 'foluonong/' + new Date().getTime() + fileObj.name;
				var obj = fileObj.name.lastIndexOf(".");
				self.ext = fileObj.name.substr(obj + 1);
				self.orginName = fileObj.name;
				self.start_time = new Date().getTime();
				
				console.log('size',sessionStorage.getItem('size'))
				var size = sessionStorage.getItem('size')*1024*1024;
				// if(self.size>size){
				// 	self.$message({message: '上传文件不可大于'+sessionStorage.getItem('size')+'mb',type: 'warning'});
				// 	return;
				// }
				
				cos.putObject({
					Bucket: 'fln-1305430688',
					/* 必须 */
					Region: 'ap-chengdu',
					/* 存储桶所在地域，必须字段 */
					Key: key,
					/* 必须 */
					StorageClass: 'STANDARD',
					Body: fileObj, // 上传文件对象
					onProgress: function(progressData) {
						var progressRes = progressData;
						console.log('progressRes', progressRes)
						self.setProgress(progressRes.percent)
					}
				}, function(err, data) {
					console.log('err', err, data)
					self.finish('http://' + data.Location);
				});

			},


			removeImg(e) {
				const self = this;
				var index = e.target.dataset.index;
				self.uploadImg.splice(index, 1);
				self.$emit('onChange', {
					field: self.field,
					value: self.uploadImg
				});
			},

			async finish(url) {
				const self = this;
				//var url ='https://qiniu.solelycloud.com/' + e.key ;    //获取到了图片的URL

				//判断文件类型渲染(H5 video标签只支持H264编码的MP4)
				var videoArray = ['mp4'];
				var imageArray = ['image', 'jpeg', 'png', 'PNG', 'JPEG', 'jpg', 'JPG'];
				var docArray = ['doc', 'xlsx', 'xls', 'csv', 'pdf', 'txt', 'ppt'];

				if (videoArray.indexOf(self.ext) != -1) {
					self.uploadImg.push({
						url: url,
						type: 'vedio',
					});
				} else if (imageArray.indexOf(self.ext) != -1) {
					self.uploadImg.push({
						url: url,
						type: 'image'
					});
				} else if (docArray.indexOf(self.ext) != -1) {
					self.uploadImg.push({
						url: url,
						title: self.orginName,
						type: 'doc'
					});
				} else {
					self.uploadImg.push({
						url: url,
						title: self.orginName,
					});
				};
				console.log('self.uploadImg', self.uploadImg,self.size)
				var jqObj = self.$refs[self.randomId];
				jqObj.value = "";
				self.$emit('onChange', {
					field: self.field,
					value: self.uploadImg
				});

				const postData = {
					data: {
						'origin_name': self.orginName,
						"title": self.orginName,
						"thirdapp_id": store.getters.getUserinfo.thirdapp_id,
						"user_no": store.getters.getUserinfo.user_no,
						"path": url,
						"prefix": store.getters.getUserinfo.thirdapp_id + '/' + self.orginName,
						"size": self.size,
						"type": self.ext,
						"origin": 2,
						"behavior": 1,
						"param": 1,
						"create_time": new Date().getTime() / 1000,
						'user_type': store.getters.getUserinfo.user_type,
					}
				};
				// var res = await plugins['api_fileAdd']({data: postData});
			},


			// 进度条
			setProgress(percent) {
				const self = this;



				self.loaded = self.size * percent;
				self.progress = parseInt(percent * 100);
				//self.size = e.size;
				console.log(self.loaded);
				if (percent == 0) {
					return;
				};

				//上传速度计算
				var nt = new Date().getTime();
				console.log('nt-self.start_time', nt - self.start_time)

				var speed = self.loaded / (nt - self.start_time) * 1000; //单位b/s

				var orginSpeed = speed;
				var units = 'b/s'; //单位名称
				if (speed / 1024 > 1) {
					speed = speed / 1024;
					units = 'k/s';
				}
				if (speed / 1024 > 1) {
					speed = speed / 1024;
					units = 'M/s';
				}
				speed = speed.toFixed(1);

				self.resttime = ((self.size - self.loaded) / orginSpeed).toFixed(1) + '-s';
				console.log('self.resttime', orginSpeed);
				self.speedUnits = speed + units;

			},

			doNormalTest(fileObj, callback) { //这里假设直接将文件选择框的dom引用传入
				const self = this;
				if (self.running) { // 如果正在计算、不允许开始下一次计算
					return;
				};
				var fileReader = new FileReader();
				fileReader.callback = callback; //创建FileReader实例
				fileReader.onload = function(e, callback) { //FileReader的load事件，当文件读取完毕时触发
					self.running = false;
					// e.target指向上面的fileReader实例
					if (fileObj.size != e.target.result.length) { //如果两者不一致说明读取出错
						alert("ERROR:Browser reported success but could not read the file until the end.");
					} else {
						self.md5Res = SparkMD5.hashBinary(e.target.result);
						this.callback();
					}
				};

				fileReader.onerror = function() { //如果读取文件出错，取消读取状态并弹框报错
					self.running = false;
					alert(
						"ERROR:FileReader onerror was triggered, maybe the browser aborted due to high memory usage.");
				};
				self.running = true;
				fileReader.readAsBinaryString(fileObj); //通过fileReader读取文件二进制码
			}


		},
		watch: {
			defaultValue() {
				if (!this.defaultValue || !Array.isArray(this.defaultValue)) {
					this.uploadImg = []
				} else {
					this.uploadImg = this.defaultValue;
				}
			},
		}

	}]
	export default Js
</script>



// WEBPACK FOOTER //
// src/components/solely-fields/TUpload.vue